// Offers ABI from thirdweb Marketplace V3
export const offersAbi = [
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "offeror",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "uint256",
        "name": "offerId",
        "type": "uint256"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "assetContract",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "address",
        "name": "seller",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "quantityBought",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "totalPricePaid",
        "type": "uint256"
      }
    ],
    "name": "AcceptedOffer",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "offeror",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "uint256",
        "name": "offerId",
        "type": "uint256"
      }
    ],
    "name": "CancelledOffer",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "offeror",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "uint256",
        "name": "offerId",
        "type": "uint256"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "assetContract",
        "type": "address"
      },
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "offerId",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "tokenId",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "quantity",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "totalPrice",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "expirationTimestamp",
            "type": "uint256"
          },
          {
            "internalType": "address",
            "name": "offeror",
            "type": "address"
          },
          {
            "internalType": "address",
            "name": "assetContract",
            "type": "address"
          },
          {
            "internalType": "address",
            "name": "currency",
            "type": "address"
          },
          {
            "internalType": "enum IOffers.TokenType",
            "name": "tokenType",
            "type": "uint8"
          },
          {
            "internalType": "enum IOffers.Status",
            "name": "status",
            "type": "uint8"
          }
        ],
        "indexed": false,
        "internalType": "struct IOffers.Offer",
        "name": "offer",
        "type": "tuple"
      }
    ],
    "name": "NewOffer",
    "type": "event"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "_offerId",
        "type": "uint256"
      }
    ],
    "name": "acceptOffer",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "_offerId",
        "type": "uint256"
      }
    ],
    "name": "cancelOffer",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "_startId",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_endId",
        "type": "uint256"
      }
    ],
    "name": "getAllOffers",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "offerId",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "tokenId",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "quantity",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "totalPrice",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "expirationTimestamp",
            "type": "uint256"
          },
          {
            "internalType": "address",
            "name": "offeror",
            "type": "address"
          },
          {
            "internalType": "address",
            "name": "assetContract",
            "type": "address"
          },
          {
            "internalType": "address",
            "name": "currency",
            "type": "address"
          },
          {
            "internalType": "enum IOffers.TokenType",
            "name": "tokenType",
            "type": "uint8"
          },
          {
            "internalType": "enum IOffers.Status",
            "name": "status",
            "type": "uint8"
          }
        ],
        "internalType": "struct IOffers.Offer[]",
        "name": "_allOffers",
        "type": "tuple[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "_startId",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_endId",
        "type": "uint256"
      }
    ],
    "name": "getAllValidOffers",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "offerId",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "tokenId",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "quantity",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "totalPrice",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "expirationTimestamp",
            "type": "uint256"
          },
          {
            "internalType": "address",
            "name": "offeror",
            "type": "address"
          },
          {
            "internalType": "address",
            "name": "assetContract",
            "type": "address"
          },
          {
            "internalType": "address",
            "name": "currency",
            "type": "address"
          },
          {
            "internalType": "enum IOffers.TokenType",
            "name": "tokenType",
            "type": "uint8"
          },
          {
            "internalType": "enum IOffers.Status",
            "name": "status",
            "type": "uint8"
          }
        ],
        "internalType": "struct IOffers.Offer[]",
        "name": "_validOffers",
        "type": "tuple[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "_offerId",
        "type": "uint256"
      }
    ],
    "name": "getOffer",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "offerId",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "tokenId",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "quantity",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "totalPrice",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "expirationTimestamp",
            "type": "uint256"
          },
          {
            "internalType": "address",
            "name": "offeror",
            "type": "address"
          },
          {
            "internalType": "address",
            "name": "assetContract",
            "type": "address"
          },
          {
            "internalType": "address",
            "name": "currency",
            "type": "address"
          },
          {
            "internalType": "enum IOffers.TokenType",
            "name": "tokenType",
            "type": "uint8"
          },
          {
            "internalType": "enum IOffers.Status",
            "name": "status",
            "type": "uint8"
          }
        ],
        "internalType": "struct IOffers.Offer",
        "name": "_offer",
        "type": "tuple"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "address",
            "name": "assetContract",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "tokenId",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "quantity",
            "type": "uint256"
          },
          {
            "internalType": "address",
            "name": "currency",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "totalPrice",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "expirationTimestamp",
            "type": "uint256"
          }
        ],
        "internalType": "struct IOffers.OfferParams",
        "name": "_params",
        "type": "tuple"
      }
    ],
    "name": "makeOffer",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "_offerId",
        "type": "uint256"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "totalOffers",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  }
] as const;